import React, { useRef } from "react";

export function useDoubleTap(onDoubleTap, { delay = 280, maxDistance = 24 } = {}) {
    const lastRef = useRef({ t: 0, x: 0, y: 0 });

    return (e) => {
        const touch = e.changedTouches?.[0];
        if (!touch) return;

        const now = Date.now();
        const { clientX: x, clientY: y } = touch;
        const dt = now - lastRef.current.t;

        const dx = x - lastRef.current.x;
        const dy = y - lastRef.current.y;
        const dist = Math.hypot(dx, dy);

        if (dt > 0 && dt < delay && dist < maxDistance) {
            lastRef.current = { t: 0, x: 0, y: 0 };
            onDoubleTap?.(e);
        } else {
            lastRef.current = { t: now, x, y };
        }
    };
}